// extracted by mini-css-extract-plugin
export default {"root":"ConfirmCodeForm_root__TSUft","input":"ConfirmCodeForm_input__r+ILj"};